module.exports = window["MaterialUI"].Tooltip;